"use client";

import React from "react";
import Link from "next/link";
import useDarkMode from "@/hooks/useDarkMode";
import RegForm from "@/components/partials/auth/reg-from";
const Register = ({ embedded = false, onSuccess = null, onShowLogin = null }) => {
  const [isDark] = useDarkMode();

  const registerContent = (
    <>
      <div className="text-center 2xl:mb-10 mb-5">
        <h4 className="font-medium">Sign up</h4>
        <div className="text-slate-500 dark:text-slate-400 text-base">
          Create an account to start using Eyam
        </div>
      </div>
      <RegForm onSuccess={onSuccess} />

      <div className="max-w-[225px] mx-auto font-normal text-slate-500 dark:text-slate-400 2xl:mt-12 mt-6 uppercase text-sm">
        Already registered?{" "}
        {embedded ? (
          <button
            type="button"
            onClick={onShowLogin}
            className="text-slate-900 dark:text-white font-medium hover:underline"
          >
            Sign In
          </button>
        ) : (
          <Link
            href="/login"
            className="text-slate-900 dark:text-white font-medium hover:underline"
          >
            Sign In
          </Link>
        )}
      </div>
    </>
  );

  if (embedded) {
    return (
      <div className="mx-auto w-full max-w-xl rounded-3xl border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-700 dark:bg-slate-800 md:p-10">
        {registerContent}
      </div>
    );
  }

  return (
    <>
      <div className="loginwrapper">
        <div className="lg-inner-column">
          <div className="left-column relative z-[1]">
            <div className="max-w-[520px] pt-20 ltr:pl-20 rtl:pr-20">
              <Link href="/">
                <img
                  src={
                    isDark
                      ? "/assets/eyamLogo.png"
                      : "/assets/images/eyamLogo.png"
                  }
                  alt=""
                  className="mb-10 w-1/3"
                />
              </Link>

              <h4 className="!text-xl text-slate-800 dark:text-slate-400 font-bold">
                Welcome to Eyam {" "}<br></br>
                <span className="text-lg !text-black font-normal ">
                  The only platform that turns social media views and attention to real cash. Promote business and get paid.
                </span>
              </h4>
            </div>
            <div className="absolute left-0 bottom-[-130px] h-full w-full z-[-1]">
              <img
                src="/assets/images/investing.svg"
                alt=""
                className="h-full w-full object-contain"
              />
            </div>
          </div>
          <div className="right-column relative bg-white dark:bg-slate-800">
            <div className="inner-content h-full flex flex-col bg-white dark:bg-slate-800">
              <div className="auth-box h-full flex flex-col justify-center">
                <div className="mobile-logo text-center mb-6 lg:hidden block">
                  <Link href="/">
                    <img
                      src={
                        isDark
                          ? "/assets/eyamLogo.png"
                          : "/assets/images/eyamLogo.png"
                      }
                      alt=""
                      className="mx-auto w-1/2"
                    />
                  </Link>
                </div>
                {registerContent}
              </div>
              <div className="auth-footer text-center">
                Copyright 2024, Eyam All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
